module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "grecaptcha": ""
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f60e4ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/forms/elements/grecaptcha.vue
// module id = 245
// module chunks = 36